"use client";

import { useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import {
  Calendar,
  FileText,
  Clock,
  Gauge,
  Car,
  User,
  FileImage,
  Key,
  ClipboardCheck,
  AlertTriangle,
  FileCheck,
  ArrowLeft,
  X as XIcon, // Add this import for the close button
} from "lucide-react";
import GreyArrow from "../assets/greyLeftAr.png";
import { format } from "date-fns";
import DashboardImage from "../assets/Pickuppreview.png";
import { Button } from "@mui/material";
import "./Css/DropoffFormPreview.css";
import Header from "./Header";
import { handleError, goBack } from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  multicar_upload_image,
  APL_LINK,
} from "../ServiceConnection/serviceconnection";
import DropFormPDF from "./DropFormPDF";
import Breadcrumb from "../CommonJquery/Breadcrumb";
export default function DropoffFormPreview() {
  const location = useLocation();
  const data = location.state.option;
  const carData = data.car_data[0];
  const booking_id = data.primary_id;
  const carimage = location.state.CarImgPath;

  // This would normally come from an API or props
  const [formData, setFormData] = useState({
    // Step 1
    Submitter: "Jane Smith",
    drop_of_date: new Date(),
    first_name: "John",
    last_name: "Doe",
    insurance: "Tripcity",
    time: "Morning",

    // Car details
    carData: {
      car_name: "Toyota Camry",
      car_no: "ABC123",
      vin: "1HGCM82633A123456",
      make_year: "2022",
      model_name: "Camry LE",
    },

    // Step 2
    odoReading: "15678",
    ipass: "12345",
    dashboardOdoImage: DashboardImage,
    ipassImg: DashboardImage,
    keyImg: DashboardImage,
    dirty_car_img: DashboardImage,
    vinnumber: "12345678",
    keyStatus: "Received Back",

    // Step 3
    carImages: {
      frontLeft: DashboardImage,
      frontRight: DashboardImage,
      backLeft: DashboardImage,
      backRight: DashboardImage,
    },
    claims: "yes",
    claimType: "Damage",
    Damagenotes:
      "Small dent on the rear bumper, scratch on driver's side door.",
    DamgeImage: [DashboardImage, DashboardImage],
    notes:
      "Vehicle returned in good condition overall. Customer mentioned the dent was from a shopping cart in a parking lot.",
  });
  const [GetdamageImg, setDamageImg] = useState([]);
  const [damnageImgPath, setdamnageImgPath] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [downloadForm, SetDownloadForm] = useState();
  // State for image preview modal
  const [previewImage, setPreviewImage] = useState(null);

  // Function to open image preview
  const openImagePreview = (imageUrl) => {
    setPreviewImage(imageUrl);
  };

  // Function to close image preview
  const closeImagePreview = () => {
    setPreviewImage(null);
  };
  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    const fd = new FormData();
    fd.append("booking_id", booking_id);
    fd.append("image_status", 3);

    await server_post_data(multicar_upload_image, fd)
      .then((Response) => {
        //console.log("Response", Response)
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setdamnageImgPath(Response.data.message.image_link);
          setDamageImg(Response.data.message.damage_image);
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };
  const childRef = useRef();
  //console.log("GetdamageImg", damnageImgPath)
  const triggerDownloadPDF = (data) => {
    SetDownloadForm(data);
    setTimeout(() => {
      if (childRef.current) {
        childRef.current.handleDownloadPDF();
      }
    }, 100);
    // childRef.current.handleDownloadPDF();
  };
  //console.log("downloadForm_data  ", downloadForm)
  return (
    <div>
      <Header />
      <div className="downLoad_PrintEnqury ">
        <DropFormPDF
          ref={childRef}
          downloadForm={downloadForm}
          carimage={carimage}
          carData={carData}
        />
      </div>
      <div className="container py-4">
        {/* <div className="d-flex justify-content-between align-items-center">
          <h1 className="fw-bold">Drop-off Form Preview</h1>
          <span className="badge bg-secondary admin-badge">Admin View</span>
        </div> */}
        <div className="pageCntn_head p-0">
          <div className="pageNameDiv ">
            <Breadcrumb
              items={[
                { label: "Bookings", path: "/Bookings" },
                { label: "Drop-off From Details", path: "/DropoffFormPreview" },
              ]}
            />
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>

        <div className="custom-tabs-container ">
          <ul className="custom-tabs" role="tablist">
            <li className="custom-tab-item" role="presentation">
              <button
                className={`custom-tab-link ${
                  activeTab === "overview" ? "active" : ""
                }`}
                onClick={() => setActiveTab("overview")}
              >
                <User className="tab-icon" />
                <span>Overview</span>
              </button>
            </li>
            <li className="custom-tab-item" role="presentation">
              <button
                className={`custom-tab-link ${
                  activeTab === "vehicle" ? "active" : ""
                }`}
                onClick={() => setActiveTab("vehicle")}
              >
                <Car className="tab-icon" />
                <span>Vehicle Condition</span>
              </button>
            </li>
            <li className="custom-tab-item" role="presentation">
              <button
                className={`custom-tab-link ${
                  activeTab === "images" ? "active" : ""
                }`}
                onClick={() => setActiveTab("images")}
              >
                <FileImage className="tab-icon" />
                <span>Vehicle Images</span>
              </button>
            </li>
            <li className="custom-tab-item" role="presentation">
              <button
                className={`custom-tab-link ${
                  activeTab === "claims" ? "active" : ""
                }`}
                onClick={() => setActiveTab("claims")}
              >
                <AlertTriangle className="tab-icon" />
                <span>Claims & Notes</span>
              </button>
            </li>
          </ul>
        </div>

        <div className="tab-content mt-4" id="formTabsContent">
          {/* OVERVIEW TAB */}
          <div
            className={`tab-pane fade ${
              activeTab === "overview" ? "show active" : ""
            }`}
          >
            <div className="row g-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <User className="icon-sm me-2" />
                      Drop-off Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Submitter</div>
                        <div className="fw-medium">
                          {data?.drop_form_submiter || "NA"}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Drop-off Date</div>
                        <div className="fw-medium d-flex align-items-center">
                          <Calendar className="icon-sm me-2 text-muted" />
                          {format(data?.entry_date, "MMMM d, yyyy")}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Drop-off Time</div>
                        <div className="fw-medium d-flex align-items-center">
                          <Clock className="icon-sm me-2 text-muted" />

                          {data?.from_time || "NA"}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Insurance Type</div>
                        <div className="fw-medium d-flex align-items-center">
                          <FileCheck className="icon-sm me-2 text-muted" />
                          {data?.insurance || "NA"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <User className="icon-sm me-2" />
                      Driver Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Full Name</div>
                        <div className="fw-medium">
                          {data.first_name} {data.last_name}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <Car className="icon-sm me-2" />
                      Vehicle Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <div className="text-muted ">Car Details</div>
                      <div className="fw-medium">
                        {carData?.car_name || "NA"} / LP#: {carData?.car_no}
                      </div>
                      <div className="small">
                        VIN#: {carData.vin} / Make Year: {carData.make_year} /
                        Model: {carData.model_name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* VEHICLE CONDITION TAB */}
          <div
            className={`tab-pane fade ${
              activeTab === "vehicle" ? "show active" : ""
            }`}
          >
            <div className="row g-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <Gauge className="icon-sm me-2" />
                      Vehicle Readings & Status
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Odometer Reading</div>
                        {console.log("data?.drop_km ", data)}
                        <div className="fw-medium">
                          {" "}
                          {data?.drop_km || "NA"} miles
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">IPASS #</div>
                        <div className="fw-medium">
                          {data?.ipass_number || "NA"}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">
                          VIN Number (Last 8 Digits)
                        </div>
                        <div className="fw-medium">{data?.vin || "NA"}</div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Key Status</div>
                        <div className="fw-medium d-flex align-items-center">
                          <Key className="icon-sm me-2 text-muted" />
                          {data?.key_status || "NA"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <FileText className="icon-sm me-2" />
                      Vehicle Documentation
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="text-muted mb-2">Dashboard (ODO)</div>
                        <img
                          src={
                            carimage + data.drop_gas_and_odo_image ||
                            "/placeholder.svg"
                          }
                          alt="Dashboard"
                          className="img-thumbnail doc-img"
                          onClick={() =>
                            openImagePreview(
                              carimage + data.drop_gas_and_odo_image
                            )
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="text-muted mb-2">IPASS Image</div>
                        <img
                          src={
                            carimage + data.ipass_picture || "/placeholder.svg"
                          }
                          alt="IPASS"
                          className="img-thumbnail doc-img"
                          onClick={() =>
                            openImagePreview(carimage + data.ipass_picture)
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="text-muted mb-2">Key Image</div>
                        <img
                          src={carimage + data.key_image || "/placeholder.svg"}
                          alt="Key"
                          className="img-thumbnail doc-img"
                          onClick={() =>
                            openImagePreview(carimage + data.key_image)
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      {formData.dirty_car_img && (
                        <div className="col-md-4 mb-3">
                          <div className="text-muted mb-2">
                            Dirty Car Interior
                          </div>
                          <img
                            src={
                              carimage + data.drop_dirty_car_img ||
                              "/placeholder.svg"
                            }
                            alt="Dirty Car Interior"
                            className="img-thumbnail doc-img"
                            onClick={() =>
                              openImagePreview(
                                carimage + data.drop_dirty_car_img
                              )
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* VEHICLE IMAGES TAB */}
          <div
            className={`tab-pane fade ${
              activeTab === "images" ? "show active" : ""
            }`}
          >
            <div className="row g-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <FileImage className="icon-sm me-2" />
                      Car Images
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="car-images-container">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <div className="car-image-card">
                            <div className="car-image-label">Driver Left</div>
                            <img
                              src={
                                carimage + data.frontLeft || "/placeholder.svg"
                              }
                              alt="Front Left View"
                              className="car-view-img cursor-pointer"
                              onClick={() =>
                                openImagePreview(carimage + data.frontLeft)
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <div className="car-image-card">
                            <div className="car-image-label">Driver Right</div>
                            <img
                              src={
                                carimage + data.frontRight || "/placeholder.svg"
                              }
                              alt="Front Left View"
                              className="car-view-img cursor-pointer"
                              onClick={() =>
                                openImagePreview(carimage + data.frontRight)
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <div className="car-image-card">
                            <div className="car-image-label">Passanger Left</div>
                            <img
                              src={
                                carimage + data.backLeft || "/placeholder.svg"
                              }
                              alt="Front Left View"
                              className="car-view-img cursor-pointer"
                              onClick={() =>
                                openImagePreview(carimage + data.backLeft)
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <div className="car-image-card">
                            <div className="car-image-label">Passanger Right</div>
                            <img
                              src={
                                carimage + data.backRight || "/placeholder.svg"
                              }
                              alt="Front Left View"
                              className="car-view-img cursor-pointer"
                              onClick={() =>
                                openImagePreview(carimage + data.backRight)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CLAIMS & NOTES TAB */}
          <div
            className={`tab-pane fade ${
              activeTab === "claims" ? "show active" : ""
            }`}
          >
            <div className="row g-4">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <AlertTriangle className="icon-sm me-2" />
                      Claims Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="text-muted ">Claims Status</div>
                        <div className="fw-medium d-flex align-items-center">
                          {data.any_claims?.toLowerCase() === "yes" ? (
                            <span className="badge bg-warning me-2">
                              Claims Filed
                            </span>
                          ) : (
                            <span className="badge bg-success me-2">
                              {data?.any_claims == "no"
                                ? "No Claims"
                                : "Yes" || "NA"}
                            </span>
                          )}
                        </div>
                      </div>
                      {data?.any_claims == "no" ? (
                        <></>
                      ) : (
                        <div className="col-md-6 mb-3">
                          <div className="text-muted ">Claim Type</div>
                          <div className="fw-medium">
                            {data?.claims_type || "NA"}
                          </div>
                        </div>
                      )}
                      {data.claims_type?.toLowerCase() === "damage" && (
                        <div className="col-12 mb-3">
                          <div className="text-muted">Damage Details</div>
                          <div className="p-3 bg-light rounded">
                            {data?.claims_type || "NA"}
                          </div>
                        </div>
                      )}

                      {data.claims_type?.toLowerCase() === "damage" && (
                        <>
                          <div className="col-12 mb-3">
                            <div className="text-muted mb-2">Damage Images</div>
                            <div className="row">
                              {GetdamageImg.map((img, index) => (
                                <div key={index} className="col-md-3 mb-3">
                                  <img
                                    src={
                                      APL_LINK + damnageImgPath + img.image ||
                                      "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                                    }
                                    alt={`Damage ${index + 1}`}
                                    className="img-thumbnail damage-img"
                                    onClick={() =>
                                      openImagePreview(
                                        APL_LINK + damnageImgPath + img.image
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg";
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <FileText className="icon-sm me-2" />
                      Additional Notes
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="p-3 bg-light rounded">
                      {data?.notes || "No additional notes provided."}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <ClipboardCheck className="icon-sm me-2" />
                      Form Status
                    </h5>
                    <div className="text-muted small">
                      Overall status of the drop-off form submission
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <span className="badge bg-success me-2">Complete</span>
                        <span className="text-muted">
                          All required fields completed
                        </span>
                      </div>

                      {/* <div>
                        <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => triggerDownloadPDF(data)}>Download</button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      {previewImage && (
        <div className="preview-modal-overlay" onClick={closeImagePreview}>
          <div
            className="preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-modal-close-btn"
              onClick={closeImagePreview}
            >
              <XIcon size={24} />
            </button>
            <img
              src={previewImage}
              alt="Preview"
              className="preview-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}
